module.exports = {"baseUrl":"https://static.parastorage.com/services/marketing-header-and-footer/1.53.0/"}


//////////////////
// WEBPACK FOOTER
// ../meta.json
// module id = 47
// module chunks = 0